import type { BranchType } from '@packages/shared-types';

// Map which branch types are available for each industry
export const INDUSTRY_BRANCH_TYPES: Record<string, BranchType[]> = {
  education: ['retail_store', 'warehouse'], // Schools and Buildings
  agriculture: ['retail_store', 'warehouse', 'distribution_center'], // Farms, Storage, Processing
  library: ['retail_store', 'warehouse', 'distribution_center'], // Locations, Branches, Main Branch
  healthcare: ['retail_store', 'warehouse', 'distribution_center'], // Facilities, Departments, Medical Centers
  retail: ['retail_store', 'warehouse', 'distribution_center'], // All types
  warehouse: ['warehouse', 'distribution_center'], // Warehouses and Distribution Centers
  default: ['retail_store', 'warehouse', 'distribution_center'], // All types
};

export function getAvailableBranchTypes(industry?: string | null): BranchType[] {
  if (!industry) {
    return INDUSTRY_BRANCH_TYPES.default;
  }
  return INDUSTRY_BRANCH_TYPES[industry] || INDUSTRY_BRANCH_TYPES.default;
}

export function getBranchTypeTranslationKey(
  type: BranchType,
  industry?: string | null,
): string {
  const baseKey = `pages.branches.form.typeOptions.${type}`;
  if (industry) {
    return `${baseKey}.${industry}`;
  }
  return baseKey;
}
